import React from "react";
import PrescriptionPreview from "./PrescriptionPreview";
import { motion } from "framer-motion";

// Safe parse function
const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    // If not valid JSON, return the raw string or empty array
    return typeof value === "string" ? [value] : [];
  }
};

// Convert array-like values into comma-separated string
const formatArrayField = (value) => {
  let parsed = safeParse(value);

  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed.replace(/'/g, '"'));
    } catch (e) {
      parsed = [parsed];
    }
  }

  return Array.isArray(parsed) ? parsed.join(", ") : parsed;
};

const parsedSymptoms = ((value) => {
  let parsed = safeParse(value);

  // If it's still a string, try JSON parse
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed.replace(/'/g, '"')); // convert single quotes to double
    } catch (e) {
      parsed = [parsed]; // fallback to array with single value
    }
  }

  return Array.isArray(parsed) ? parsed.join(", ") : parsed;
})

const PrescriptionHistory = ({ prescriptions, onDateChange, onBackClick, selectedDate }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-6xl mx-auto px-4 py-6"
    >
      {/* Top Controls */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center mb-8 mt-6">
        {/* Date Picker */}
        <div className="flex justify-start">
          <input
            type="date"
            value={selectedDate}
            onChange={onDateChange}
            className="w-full md:w-auto border border-gray-300 px-4 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Heading */}
        <div className="flex justify-center">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-blue-700 text-center">
            🩺 Prescription History
          </h1>
        </div>

        {/* Back Button */}
        <div className="flex justify-end">
          <button
            onClick={onBackClick}
            className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md transition"
          >
            ⬅️ Back to Patients
          </button>
        </div>
      </div>

      {/* Prescription List */}
      {prescriptions.length === 0 ? (
        <p className="text-center text-gray-600 text-base md:text-lg">
          No prescriptions available.
        </p>
      ) : (
        prescriptions.map((prescription, index) => {
          // Parse fields before passing to PrescriptionPreview
          // const symptoms = parsedSymptoms(prescription.symptoms);
          // const medicines = formatArrayField(prescription.medicines);
          // const labTests = formatArrayField(prescription.labTests);
          const sos = formatArrayField(prescription.sos);
          // {console.log((prescription.labTests))}

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, duration: 0.4 }}
              className="mb-10 bg-white shadow-lg rounded-xl p-4 sm:p-6 border border-blue-100"
            >
              <PrescriptionPreview
                patientName={prescription.patientName}
                date={prescription.date}
                symptoms={Array.isArray(prescription.symptoms) ? prescription.symptoms.join(", ") : prescription.symptoms}
                diagnosis={prescription.diagnosis}
                medicines={(prescription.medicines)}
                labTests={(prescription.labTests)}
                sos={sos}
                notes={prescription.notes}
                nextAppointment={prescription.nextAppointment}
              />
            </motion.div>
          );
        })
      )}
    </motion.div>
  );
};

export default PrescriptionHistory;
